(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pre-header"]) return;
  try {
    
  class StickyPreHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-pre-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-pre-header', StickyPreHeader);

  document.addEventListener('DOMContentLoaded', function() {
    const selectedDateEl = document.getElementById("selectedDate");
    const tooltipEl = document.getElementById("tooltiptext")

    const today = new Date(); // Get today's date

    // Create new Date objects for tomorrow, day after tomorrow, and 2 days after tomorrow
    const tomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
    const dayAfterTomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2);
    const twoDaysAfterTomorrow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3);


    // Function to format the date in a specific format
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    };

    // Formatted dates 
    const tomorrowFormatted = formatDate(tomorrow);
    const dayAfterTomorrowFormatted = formatDate(dayAfterTomorrow);
    const twoDaysAfterTomorrowFormatted = formatDate(twoDaysAfterTomorrow);

    // Array containing weekdays
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // Get weekdays for each date
    const tomorrowWeekday = weekdays[tomorrow.getDay()];
    const dayAfterTomorrowWeekday = weekdays[dayAfterTomorrow.getDay()];
    const twoDaysAfterTomorrowWeekday = weekdays[twoDaysAfterTomorrow.getDay()];

    const tooltipHTML = `
          <div class="delivery-container">
            <span class="delivery-label">Select a delivery day</span>
            <ul class="delivery-options">
              <li class="delivery-option" data-delivery-date="${tomorrow}"">Tomorrow (${tomorrowFormatted})</li>
              <li class="delivery-option" data-delivery-date="${dayAfterTomorrow}">${dayAfterTomorrowWeekday} (${dayAfterTomorrowFormatted})</li>
              <li class="delivery-option" data-delivery-date="${twoDaysAfterTomorrow}">${twoDaysAfterTomorrowWeekday} (${twoDaysAfterTomorrowFormatted})</li>
            </ul>
          </div>
    `;

    const tempContainer = document.createElement("div");

    // Set the innerHTML of the tempContainer (parsing potential escaping issues)
    tempContainer.innerHTML = tooltipHTML;

    // Extract the desired content from the tempContainer (optional)
    const deliveryContainer = tempContainer.querySelector(".delivery-container");

    // Check if desired content is found
    if (deliveryContainer) {
        // Set the tooltip content using the extracted element (optional)
        tooltipEl.appendChild(deliveryContainer); // Or set tooltipEl.innerHTML directly
    } else {
        console.error("Delivery container not found in tooltip HTML.");
    }

    
     // Check for existing selection from localStorage
    const storedDeliveryDate = localStorage.getItem('delivery-date');
    if (storedDeliveryDate && storedDeliveryDate < new Date().toISOString()) {
        const deliveryOptions = tooltipEl.querySelectorAll('.delivery-option');
        // console.log(deliveryOptions);
        deliveryOptions.forEach(option => {
          // console.log(option.dataset.deliveryDate, storedDeliveryDate, option.dataset.deliveryDate === storedDeliveryDate);
          if (option.dataset.deliveryDate === storedDeliveryDate) {
            setSelected(option, storedDeliveryDate);
          }
        });
    } else {
        // If no selection is found, set the first option as selected
        const firstOption = tooltipEl.querySelector('.delivery-option');
        if (firstOption) {
          localStorage.setItem('delivery-date', firstOption.dataset.deliveryDate);
          setSelected(firstOption, firstOption.dataset.deliveryDate);
        }
    }

      // Attach click event listener to the tooltip element
    const deliveryOptions = tooltipEl.querySelectorAll('.delivery-option').forEach(option => {
        option.addEventListener('click', handleDeliveryClick.bind(this));
    });

    selectedDateEl.addEventListener("click", function() {
      tooltipEl.classList.toggle("show");

      // Position the tooltip below the selectedDateEl
      const tooltipRect = tooltipEl.getBoundingClientRect();
      const selectedDateRect = selectedDateEl.getBoundingClientRect();
      tooltipEl.style.top = `${selectedDateRect.bottom + 5}px`; // Add a 5px offset for spacing
      tooltipEl.style.left = `${selectedDateRect.left}px`;
    });

    document.addEventListener("click", function(event) {
      // Check if the clicked element is not the selectedDateEl or a descendant of tooltipEl
      if (!selectedDateEl.contains(event.target) && event.target !== tooltipEl) {
        // Hide the tooltip
        tooltipEl.classList.remove("show");
      }
    })

    function setSelected(element, selectedDate) {
      tooltipEl.querySelectorAll('.delivery-option').forEach(option => {
        option.classList.remove('selected');
      });
      element.classList.add('selected');
      const deliveryDateText = document.getElementById("deliveryDateText");

      // console.log(selectedDate , new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1))
      if (selectedDate == new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1)) {
        deliveryDateText.innerHTML = "Tomorrow";
      } else {
        deliveryDateText.innerHTML = new Date(element.dataset.deliveryDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
      }
    }

    function handleDeliveryClick(event) {
      event.stopPropagation();
      const clickedElement = event.target;
      if (clickedElement.classList.contains('delivery-option')) {
        // console.log(clickedElement.dataset, clickedElement);
        const selectedDeliveryDate = clickedElement.dataset.deliveryDate;
        localStorage.setItem('delivery-date', selectedDeliveryDate);

        setSelected(clickedElement, selectedDeliveryDate);
      }
    }
  });


  } catch(e) { console.error(e); }
})();
})();
